<template>
    <layout name="LayoutDefault">
        <div class="About">
            <div class="breadcrumbs">
                <div class="container">
                    <div class="row">
                        <div class="col-auto">
                            <h3>অনুসন্ধান {{ this.$route.query.keyword }} এর ফলাফল</h3>
                        </div>
                        <div class="col-auto ml-auto">
                            <ul class="list-inline">
                                <li class="list-inline-item"><a class="text-white" href="/">হোম</a></li>
                                <li class="list-inline-item">/</li>
                                <li class="list-inline-item text-white text-uppercase">বই এর নাম দ্বারা অনুসন্ধান করুন</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row">
                        <div class="col-lg-12 ">

                            <div class="section-items">
                                <div class="row">

                                    <div v-for="(item, k) in products" class="col-lg-2 col-sm-6 col-6" v-bind:key="k">
                                        <BookCard
                                            :item="item"
                                            @add-to-cart="addToCart"
                                        />
                                    </div>

                                    <div v-if="loading">Loading...</div>
                                    <div v-if="products.length < 1 && !loading">কোন বই খুজে পাওয়া যাইনি</div>

                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <!-- /.container -->

        </div>
    </layout>
</template>

<script>
import Layout from '../layouts/Layout';
import VueLoadImage from 'vue-load-image';
import BookCard from '../components/BookCard.vue';

export default {
    data() {
        return {
            products: [],
            loading: true,
        }
    },
    components: {
        Layout,
        VueLoadImage,
        BookCard
    },
    methods: {
        getProducts() {
            fetch(this.APIURL + 'products-resources/search/' + this.$route.query.keyword)
                .then(response => response.json())
                .then(json => { this.products = json.data; this.loading = false })
        },
        addToCart(row) {
            let itemObj = {
                session_id: localStorage.getItem("session_id"),
                product_id: row.id,
                image: row.image,
                price: row.price,
                quantity: 1,
                name: row.product_name
            };
            this.$helper.saveToCart(itemObj);
            var cartCount = this.$helper.cartCount();
            $(".cart-count").text(cartCount);
            this.flashMessage.success({ message: "Added item to cart" });
        }
    },
    mounted() {
        this.getProducts();
    }
};
</script>
